import React from "react"
import type { DashboardQuickLink } from "../types"
import DashboardQuickLinkCard from "./DashboardQuickLink"
import "./DashboardQuickLinks.style.scss"

interface DashboardQuickLinksProps {
  links: DashboardQuickLink[]
}

const DashboardQuickLinks = ({ links }: DashboardQuickLinksProps) => (
  <div className="dashboard-quick-links">
    {links.map((link) => (
      <DashboardQuickLinkCard key={link.path} link={link} />
    ))}
  </div>
)

export default DashboardQuickLinks
